var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aliContainer workbenchTool mb1",attrs:{"id":"workbenchTool"}})
}
var staticRenderFns = []

export { render, staticRenderFns }